export default __webpack_public_path__ + "60cca0932810ddc48a99530a899ae047.svg";